'use strict';

const Reflux = require('@muzzylane/reflux');

const CourseWebsocketActions = require('../actions/CourseWebsocketActions');
const SignInStore = require('./SignInStore');
const ForgeError = require('../util/error');
const ErrorConsts = require('../constants/error');

const MAX_RECONNECTS = GlobalConfig.WebSocketOptions.reconnectionAttempts;
const RECONNECT_DELAY = GlobalConfig.WebSocketOptions.reconnectionDelay;
// const MAX_RECONNECTS = 0; //testing failed
const REFRESH_LOCK_TIME = parseInt(GlobalConfig.WebSocketOptions.activityLockDuration, 10) / 2;

let initialized = false;
let storeState = "";
let message = "";
let signedIn = false;
let action = {};
let error = null;

let connection_lost = false;
let connection_perm_lost = false;
let refreshLockInterval = -1;
let flagToDisconnect = false;
let force_unlock_data = null;

let cWebsocket = null;
let reconnectAttempt = 0;

var CourseWebsocketStore = Reflux.createStore({
    listenables: [CourseWebsocketActions],
    init: function() {
        signedIn = SignInStore.getState().initializedLocal;
        this.listenTo(SignInStore, this.onSignInChange);
    },

    onSignInChange: function(signInStoreState){
        signedIn = signInStoreState.initializedLocal;
    },

    getState: function() {
        return {
            initialized: initialized,
            cWebsocket: cWebsocket,
            error: error,
            action: action,
            connection_lost: connection_lost,
            connection_perm_lost: connection_perm_lost,
            force_unlock_data: force_unlock_data, // indicates when we get a force unlock 'request'
        }
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
        error = null;
    },

    _resetStoredWebsocket() {
        initialized = false;
        reconnectAttempt = 0;
        connection_lost = false;
        connection_perm_lost = false;
        cWebsocket = null;
    },

    onGetCourseLockCompleted: function(actionID, cWS) {
        console.log("in onGetCourseLockCompleted");
        action = { id: actionID };
        cWebsocket = cWS;
        initialized = true;
        connection_lost = false;
        connection_perm_lost = false;

        this._setupConnectionListeners();
        this.emitStatus();
    },

    onGetCourseLockFailed: function(actionID, cWS, courseId, err) {
        console.warn("onGetCourseLockFailed: ", actionID, courseId, err);
        action = { id: actionID };

        if (err && err.step) {
            switch (err.step) {
                case "ws_url":
                    //todo
                    break;
                case "ws_connect":
                    //todo
                    break;
                case "ws_authenticate":
                    //todo
                    break;
                case "test_course_lock":
                    //todo
                    break;
                case "request_course_lock":
                    //todo
                    break;
                case "reestblish_course_lock":
                    //todo
                    break;
                default:
                    break;
            }
        }
        else {
            console.warn("onGetCourseLockFailed no error, non-standard error returned!");
        }

        // if(err.status){
        //     switch(err.status){
        //         default:
        //             action.error = new ForgeError({message: ErrorConsts.INTERNAL_GENERAL});
        //     }
        // }
        // else {
        //     action.error = err;
        // }

        cWebsocket = cWS;
        initialized = true;
        error = err;

        this.emitStatus();
    },

    onReestablishCourseLockCompleted: function(actionID, cWS) {
        // console.log("in onReestablishCourseLockCompleted!");
        action = { id: actionID };
        cWebsocket = cWS;
        initialized = true;
        connection_lost = false;
        connection_perm_lost = false;
        reconnectAttempt = 0;
        this._setupConnectionListeners();
        this.emitStatus();

        // testing disconnect
        // window.setTimeout(function() {
            // cWebsocket.sock.disconnect();
        // }, 10000);
    },

    onReestablishCourseLockFailed: function(actionID, activityId, err) {
        console.warn("onReestablishCourseLockFailed: ", actionID, activityId, err);
        this._attemptReconnect();
    },

    onReleaseCourseLockCompleted: function(actionID, activityId) {
        // console.log("in onReleaseCourseLockCompleted!");
        this._removeRefreshLockInterval();
        action = { id: actionID };
        this._resetStoredWebsocket();
        this.emitStatus();
    },

    onReleaseCourseLockFailed: function(actionID, err) {
        console.error("in onReleaseCourseLockFailed!", err);
        this._removeRefreshLockInterval();
        action = { id: actionID };
        this._resetStoredWebsocket();
        //todo: error handling
        this.emitStatus();
    },
    
    // onClearForceUnlockStateCompleted: function(actionId) {
    //     action = { id: actionId };
    //     force_unlock_data = null;
    //     this.emitStatus();
    // },
    // onClearForceUnlockStateFailed: function(actionId) {
    //     action = { id: actionId };
    //     this.emitStatus();
    // },

    _attemptReconnect: function() {
        const self = this;
        if (reconnectAttempt < MAX_RECONNECTS) {
            window.setTimeout(function() {
                console.log(`reconnect attempt ${(reconnectAttempt + 1)}/${MAX_RECONNECTS}`);
                reconnectAttempt++;
                CourseWebsocketActions.reestablishCourseLock('store-reset-c-lock', {
                    cWebsocket: cWebsocket
                });
            }, reconnectAttempt > 0 ? RECONNECT_DELAY : 0);
        }
        else {
            connection_perm_lost = true;
            cWebsocket.disconnect()
                .then(function() {
                    self.emitStatus();
                });
        }
    },

    _setupConnectionListeners: function() {
        const self = this;
        console.log('_setupConnectionListeners flagToDisconnect:', flagToDisconnect);
        if (flagToDisconnect) {
            //TODO: calling action from store breaks flux pattern. not sure how else to trigger this action
            //console.log('calling CourseWebsocketActions.releaseCourseLock due to flagToDisconnect');
            CourseWebsocketActions.releaseCourseLock('flag-release', { cWebsocket: cWebsocket });
            flagToDisconnect = false;
        }
        
        function messageHandler(msg) {
            //console.log('CourseWebsocketStore messageHandler msg', msg);
            return;
            // if (msg.type === 'force_activity_unlock') {
            //     force_unlock_data = {
            //         start_time: new Date(),
            //         timeout_ms: GlobalConfig.WebSocketOptions.forceUnlockTime,
            //         id: msg.id, // forge activity id
            //         activityID: msg.activityID, // nova_act_id,
            //         kickerName: msg.kickerName,
            //         clientResponseToken: msg.clientResponseToken,
            //     };
            //     self.emitStatus();
            // }
        }

        function disconnectCallback() {
            connection_lost = true;
            cWebsocket.sock.removeListener("msg", messageHandler);
            cWebsocket.sock.removeListener("disconnect", disconnectCallback);
            self._removeRefreshLockInterval();
            self._attemptReconnect();
            self.emitStatus();
        }

        cWebsocket.sock.on("disconnect", disconnectCallback);
        cWebsocket.sock.on("msg", messageHandler);
        this._addRefreshLockInterval();
    },

    _addRefreshLockInterval: function() {
        this._removeRefreshLockInterval();
        console.debug('_addRefreshLockInterval REFRESH_LOCK_TIME', REFRESH_LOCK_TIME);
        refreshLockInterval = window.setInterval(function() {
            CourseWebsocketActions.refreshCourseLock(
                'course-lock-refresh',
                { cWebsocket: cWebsocket }
            );
        }, REFRESH_LOCK_TIME);
    },

    _removeRefreshLockInterval: function() {
        console.debug('_removeRefreshLockInterval', refreshLockInterval);
        if (refreshLockInterval >= 0) {
            console.debug('_removeRefreshLockInterval clearInterval');
            window.clearInterval(refreshLockInterval);
            refreshLockInterval = -1;
        }
    },

    onRefreshCourseLockCompleted: function(actionID, cWS) {
        // console.log("in onRefreshCourseLockCompleted!");
        //need cWebsocket = cWS ?
        this.emitStatus();
    },

    onRefreshCourseLockFailed: function(actionID, err) {
        console.error("in onRefreshCourseLockFailed!", err);
    },

    // onUpdateActivityVersionCompleted: function(actionID, version) {
    //     // console.log("in onUpdateActivityVersionCompleted!", actionID, version);
    //     if (cWebsocket) {
    //         cWebsocket.activityVersion = version;
    //     }
    //     else {
    //         console.warn("cWebsocket not found in CourseWebsocketStore");
    //     }

    //     this.emitStatus();
    // },

    // onUpdateActivityVersionFailed: function(actionID, err) {
    //     console.error("in onUpdateActivityVersionFailed!", err);
    //     this.emitStatus();
    // },

    //resetStoreCompleted is called when EditActivity does not currently have activity lock
    onResetStoreCompleted: function(actionId, lockProcessBegun) {
        console.debug("in onResetStoreCompleted!", actionId);
        this._removeRefreshLockInterval();
        action = { id: actionId };
        if (cWebsocket && cWebsocket.isConnecting) { //if activity lock WS is pending flag to disconnect when connection is completed
            console.log('cWebsocket && cWebsocket.isConnecting - flagToDisconnect set to true');
            flagToDisconnect = true;
        }
        else if (!cWebsocket && lockProcessBegun) {
            console.log('!cWebsocket && lockProcessBegun - flagToDisconnect set to true');
            flagToDisconnect = true; // if cWebsocket does not yet exist and the component has begun the locking action, we're still waiting on onGetCourseLockCompleted/Failed
        }
        else {
            console.log('else - flagToDisconnect set to false')
            flagToDisconnect = false;
        }

        this._resetStoredWebsocket();
        this.emitStatus();
    },

    onDevTestWSDisconnectCompleted: function() {
        console.debug("DEV: disconnecting course websocket...");
        cWebsocket.sock.disconnect();
    }
});

module.exports = CourseWebsocketStore;
